<template>
  <notifications
    class="notification__container"
    :group="props.group"
    :position="props.position"
    :width="props.width"
  >
    <template #body="{ item, close }">
      <NavBar
        sticky
        :style="`background-color: ${getBackgroundColor(item.type)};`"
      >
        <template #left>
          <slot name="left" :item="item" />
        </template>

        <template #center>
          <slot name="center" :item="item">
            <p
              class="notification__text"
              :style="`color: ${getTextColor(item.type)};`"
            >
              {{ item.text }}
            </p>
          </slot>
        </template>

        <template #right>
          <slot name="right" :item="item">
            <button
              title="Fechar notificação"
              aria-label="Fechar notificação"
              class="notification__button"
              type="button"
              @click="close"
            >
              <RoundedIcon
                has-hover
                icon-name="ic_cancel"
                main-color="transparent"
                :hover-color="NebraskaColors.backgroundHover"
                :hover-text-color="getTextColor(item.type)"
                :text-color="getTextColor(item.type)"
              />
            </button>
          </slot>
        </template>
      </NavBar>
    </template>
  </notifications>
</template>

<script lang="ts" setup>
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

import { RoundedIcon, NavBar } from '@warrenbrasil/nebraska-web';
import { NotificationTypes } from '@/modules/common/services/http/notification';

interface Props {
  group: string;
  position?: string;
  width?: string;
}

const props = withDefaults(defineProps<Props>(), {
  position: 'top center',
  width: '100%'
});

function getColors(type: NotificationTypes) {
  switch (type) {
    case NotificationTypes.error:
      return {
        color: NebraskaColors.statusNegative,
        background: NebraskaColors.statusNegativeBackground
      };
    case NotificationTypes.success:
      return {
        color: NebraskaColors.statusPositive,
        background: NebraskaColors.statusPositiveBackground
      };
    case NotificationTypes.info:
      return {
        color: NebraskaColors.statusInfo,
        background: NebraskaColors.statusInfoBackground
      };
    case NotificationTypes.alert:
      return {
        color: NebraskaColors.statusAlert,
        background: NebraskaColors.statusAlertBackground
      };
    case NotificationTypes.primary:
    default:
      return {
        color: NebraskaColors.textNegative,
        background: NebraskaColors.neutralPrimary
      };
  }
}

function getTextColor(type: NotificationTypes) {
  return getColors(type).color;
}

function getBackgroundColor(type: NotificationTypes) {
  return getColors(type).background;
}
</script>

<style lang="less" scoped>
.notification {
  &__container {
    z-index: 5001;
  }

  &__button {
    padding: 0;
  }

  &__text {
    .text-p-6();
    font-weight: 600;
  }
}
</style>
